// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jD5Y","icon":"styles_icon__gUgdO"};